module.exports = __webpack_public_path__ + "static/tribal-7968f04857b9ed78cb8c2df17cc77a6e.svg";